import { type ReactNode } from 'react';

export const ConditionalWrapper = ({
  condition,
  wrapper,
  children,
}: {
  condition: boolean;
  wrapper: (arg: ReactNode) => ReactNode;
  children: ReactNode;
}) => (condition ? wrapper(children) : children);
